import React from "react";
import map1 from "@maps/map-1.JPG";
import Comments from "../comments/Comments";
import {BankFilled, ContainerFilled, DatabaseOutlined, EnvironmentFilled, SettingOutlined, UploadOutlined} from "@ant-design/icons";
import {Breadcrumb, Button, Tooltip, Upload} from "antd";
import LayoutComponent from "@ui/layout/LayoutComponent";
import "./cod-single.scss";
import {Link} from "react-router-dom";
import NewComment from "../comments/new-comment/NewComment";

const CodSingleComponent = () => {
    let cod = {
        name: 'AWO KL NASA',
        location: 'Los Angeles, Kenesary Khan avenue, 777',
        owner: 'NASA',
        systems: [
            {
                system: 'Информационная система космической связи "Apollo"'
            },
            {
                system: 'Информационная система технической защиты информации "Cyber Guard"'
            },
            {
                system: 'Информационная система метеорологического прогноза "Zeus"'
            }
        ],
    }

    return (
        <LayoutComponent>
            <div className="breadcrumb">
                <Breadcrumb
                    style={{
                        margin: '16px 0',
                    }}
                >
                    <Breadcrumb.Item>
                        <SettingOutlined/>
                        <span>Сервисы</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={'/cod'}>
                            <DatabaseOutlined/>
                            <span>ЦОД</span>
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <span>{cod.name}</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div className="cod-single">
                <div className="row">
                    <div className="card">
                        <div className="title">Описание</div>
                        <div className="card-description">
                            <div className="name-block">
                                <h4>Название</h4>
                                <span><Tooltip title="Название"><ContainerFilled /></Tooltip></span>
                                <span>{cod.name}</span>
                            </div>
                            <div className="location-block">
                                <h4>Адрес</h4>
                                <span><Tooltip title="Адрес"><EnvironmentFilled /></Tooltip></span>
                                <span>{cod.location}</span>
                            </div>
                            <div className="owner">
                                <h4>Владелец</h4>
                                <span><Tooltip title="Владелец"><BankFilled /></Tooltip></span>
                                <span>{cod.owner}</span>
                            </div>
                            <div className="systems">
                                <h4>Какие ИС находятся</h4>
                                {cod.systems.map((system, index) => (
                                    <div className="item-list" key={index}>
                                        <div className="item-block"><span className="item"></span></div>
                                        <div className="name-block"><span>{system.system}</span></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="card-map">
                        <img src={map1} alt=""/>
                        <Upload>
                            <Button type="primary" icon={<UploadOutlined />}>
                                Обновить картинку
                            </Button>
                        </Upload>
                    </div>
                </div>
                <div className="comments">
                    <div className="card">
                        <Comments/>
                        <NewComment />
                    </div>
                </div>
            </div>
        </LayoutComponent>
    )
}

export default CodSingleComponent;
